import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { classNames } from 'shared/lib/utils/classNames';
import { Loader } from 'shared/ui/Loader';
import { Text } from 'shared/ui/Text';

import { MenuItem } from '../../hooks/menu.types';
import cls from './NavigationGroupItems.module.scss';

type NavigationGroupItemsProps = {
  items: MenuItem[] | Promise<MenuItem[]>;
};

export function NavigationGroupItems(props: NavigationGroupItemsProps) {
  const { items } = props;

  const [_items, setItems] = useState<MenuItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (items instanceof Promise) {
      setIsLoading(true);
      items.then(setItems).finally(() => setIsLoading(false));
    } else {
      setItems(items);
      setIsLoading(false);
    }
  }, [items]);

  return (
    <div className={cls.Wrapper}>
      {isLoading && <Loader />}

      {!isLoading && _items.length === 0 && (
        <div className={cls.Empty}>
          <Text variant='caption'>Раздел в разработке</Text>
        </div>
      )}

      {!isLoading &&
        _items.map((item) => (
          <NavLink
            key={item.title + item.link}
            to={{ pathname: item.link }}
            className={({ isActive, isPending }) =>
              classNames(cls.Item, {
                [cls.ItemPending]: isPending,
                [cls.ItemActive]: isActive,
              })
            }
          >
            <Text variant='b1'>{item.title}</Text>
          </NavLink>
        ))}
    </div>
  );
}
